import * as larvitar from "larvitar/dist/larvitar";

const csTools = larvitar.cornerstoneTools;
const getNewContext = csTools.importInternal("drawing/getNewContext");
const draw = csTools.importInternal("drawing/draw");
const drawHandles = csTools.importInternal("drawing/drawHandles");

class LandmarkProbeNoTextTool extends csTools.ProbeTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "LandmarkProbeNoText",
      configuration: {
        color: "#00E5FF",
        preventHandleOutsideImage: true
      }
    };
    super(props, defaultProps);
  }

  // Readonly: no new measurements
  createNewMeasurement() {
    return null;
  }

  renderToolData(evt) {
    const eventData = evt.detail;
    if (!eventData || !eventData.element) {
      console.warn("Landmark overlay missing render event data.");
      return;
    }
    const toolData = csTools.getToolState(evt.currentTarget, this.name);
    if (!toolData || !toolData.data || toolData.data.length === 0) {
      return;
    }
    const context = getNewContext(eventData.canvasContext.canvas);
    if (typeof draw !== "function" || typeof drawHandles !== "function") {
      console.warn("Landmark overlay missing drawing helpers.");
      return;
    }
    const toolColors = csTools.toolColors;

    draw(context, drawContext => {
      for (let i = 0; i < toolData.data.length; i++) {
        const data = toolData.data[i];
        if (!data.visible) continue;
        const handle = data.handles && data.handles.end;
        if (!handle) continue;

        const color =
          data.color ||
          (toolColors && typeof toolColors.getColorIfActive === "function"
            ? toolColors.getColorIfActive(data)
            : "#00E5FF");

        drawHandles(
          drawContext,
          eventData,
          { end: handle },
          {
            color,
            fill: color,
            handleRadius: 5,
            drawHandlesIfActive: false,
            hideHandlesIfMoving: false
          }
        );
      }
    });
  }
}

export default LandmarkProbeNoTextTool;
